export { InputField as default } from './input'
